import React from 'react';
import PropTypes from 'prop-types'
import './Pagination.css'

const propTypes = {
    onChangePage: PropTypes.func.isRequired,
    totalPages: PropTypes.number.isRequired,
    firstItemIndex: PropTypes.number,
    currentPage: PropTypes.number,
    inactive: PropTypes.bool
}

const defaultProps = {
    currentPage: 1,
    firstItemIndex: 1
}

function range(size, startAt = 0) {
    return [...Array(size).keys()].map(i => i + startAt);
}

class Pagination extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputPage: 1
        };
    }

    setPage(page) {
        var pager = this.getPager();

        if (page < 1 || page > pager.totalPages) {
            return;
        }

        // get new pager object for specified page
        pager = this.getPager(this.props.totalPages, page);

        // call change page function in parent component
        this.props.onChangePage(page);
    }

    paginatorClickHandler = (pageToSet) => () => this.setPage(pageToSet);

    getPager() {
        const totalPages = this.props.totalPages
        let currentPage = this.props.currentPage
        // default page size is 100
        const pageSize = 100
        // default to first page
        currentPage = currentPage || 1;

        let startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        const startIndex = (currentPage - 1) * pageSize;

        // create an array of pages to ng-repeat in the pager control
        const pages = range(endPage + 1 - startPage, startPage);

        // return object with all pager properties required by the view
        return {
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            pages: pages
        };
    }

    limitMaxMin = num => {
        return Math.min(Math.max(num, 1), this.props.totalPages)
    }

    render() {
        const pager = this.getPager();

        return (
            <div className="row">
				<div className="pager col">
	                <ul className="pagination col" id='paginator'>
	                    <li className={'page-item '+(pager.currentPage === 1 ? 'disabled' : '')}>
	                        <button className="page-link" tabIndex="0" onClick={this.paginatorClickHandler(1)}>Fyrsta</button>
	                    </li>
	                    <li className={'page-item '+(pager.currentPage === 1 ? 'disabled' : '')}>
	                        <button className="page-link" tabIndex="0" onClick={this.paginatorClickHandler(pager.currentPage - 1)}>Fyrri</button>
	                    </li>
	                    {pager.pages.map((page, index) =>
	                        <li key={index} className={'page-item '+(pager.currentPage === page ? 'active' : '')}>
	                            <button className="page-link" tabIndex="0" onClick={this.paginatorClickHandler(page)}>{page}</button>
	                        </li>
	                    )}
	                    <li className={'page-item '+(pager.currentPage === pager.totalPages ? 'disabled' : '')}>
	                        <button className="page-link" tabIndex="0" onClick={this.paginatorClickHandler(pager.currentPage + 1)}>Næsta</button>
	                    </li>
	                    <li className={'page-item '+(pager.currentPage === pager.totalPages ? 'disabled' : '')}>
	                        <button className="page-link" tabIndex="0" onClick={this.paginatorClickHandler(pager.totalPages)}>Aftasta</button>
	                    </li>
	                </ul>
				</div>
				<div className="form-inline col">
					<form className="form-group  pager-input">
						<label className="mr-2">Fara beint á síðu:</label>
						<input type="number" className="form-control mr-2" value={this.state.inputPage} onChange={e => this.setState({inputPage: e.target.value ? this.limitMaxMin(e.target.value) : ''})} />
						<button className="btn" onClick={e => this.setPage(this.state.inputPage)}>Staðfesta</button>
					</form>
				</div>
            </div>
        );
    }
}

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps
export default Pagination;



// WEBPACK FOOTER //
// ./src/Components/Pagination.js